"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteQuoteRelation = exports.postQuoteRelation = exports.putQuoteOrganization = exports.putQuoteAccessibility = exports.deleteQuotePermission = exports.postQuotePermission = exports.putQuoteAction = exports.postQuote = exports.putQuote = exports.getQuote = exports.getQuotes = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var quotesAuthorizedPath = root_1.ecommerceAuthorized + '/quotes/';

var getQuotes = function getQuotes(authentication, queryParameters) {
  return common_1.get(authentication, quotesAuthorizedPath, queryParameters);
};

exports.getQuotes = getQuotes;

var getQuote = function getQuote(authentication, id) {
  return common_1.get(authentication, quotesAuthorizedPath + id);
};

exports.getQuote = getQuote;

var putQuote = function putQuote(authentication, quote) {
  return common_1.put(authentication, quotesAuthorizedPath + quote.id, quote);
};

exports.putQuote = putQuote;

var postQuote = function postQuote(authentication, quote) {
  return common_1.post(authentication, quotesAuthorizedPath, quote);
};

exports.postQuote = postQuote;

var putQuoteAction = function putQuoteAction(authentication, id, action, data) {
  return common_1.putSub(authentication, quotesAuthorizedPath, id, action, data);
};

exports.putQuoteAction = putQuoteAction;

var postQuotePermission = function postQuotePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, quotesAuthorizedPath, id, permission);
};

exports.postQuotePermission = postQuotePermission;

var deleteQuotePermission = function deleteQuotePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, quotesAuthorizedPath, id, permissionId);
};

exports.deleteQuotePermission = deleteQuotePermission;

var putQuoteAccessibility = function putQuoteAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, quotesAuthorizedPath, id, accessibility);
};

exports.putQuoteAccessibility = putQuoteAccessibility;

var putQuoteOrganization = function putQuoteOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, quotesAuthorizedPath, id, organizationId);
};

exports.putQuoteOrganization = putQuoteOrganization;

var postQuoteRelation = function postQuoteRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, quotesAuthorizedPath, id, relation);
};

exports.postQuoteRelation = postQuoteRelation;

var deleteQuoteRelation = function deleteQuoteRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, quotesAuthorizedPath, id, relationId);
};

exports.deleteQuoteRelation = deleteQuoteRelation;